import React, { Component } from 'react'
import {
  Table, 
  TableContainer, 
  TableHead, 
  TableBody, 
  TableCell, 
  TableRow,
  withStyles
} from '@material-ui/core';
import { TitleCard, CollapseRow, BackButton } from '../../../components/index'; 
import './Product.css';
import { AuthContext } from '../../../auth/AuthHandler';
import { ReleaseTrackerDataService } from '../../../data/ReleaseTrackerDataService';

const styles = {
  thead: {
    fontWeight: 'bold'
  }, // a nested style rule
  tableContainer: {
    width: '100%', 
    '@media(min-width:792px)': {
      width: '790px', 
    },
    '@media(min-width: 962px)':{
      width: '950px',
    },
    margin: '5px'
  }
}

class Product extends Component{

  static contextType = AuthContext

  constructor(props) {
    super(props)
    
    const { locks_or_peripherals, url } = this.props.match.params;
    this.state = {
      firmwares: [],
      deviceType: locks_or_peripherals,
      familyName: url,
    }
    
  }
  
  componentDidMount() {
    this.relTrackerService = new ReleaseTrackerDataService(this.context);
    this.relTrackerService.getFirmwareFamiliesFirmwares(this.state.deviceType, this.state.familyName)
      .then(data => {
        this.setState({
          firmwares: data,
        })
      })
      .catch(err => {
        console.error(err);
      });
  }

  getVersions(value, setVersions) {
    console.log(value)
    this.relTrackerService.getFirmwareFamiliesFirmwareVersions(this.state.deviceType, this.state.familyName, value.Name)
      .then(data => {
        setVersions(data)
      })
      .catch(err => {
        console.error(err);
        setVersions([])
      });
  }

  render(){
    const { url } = this.props.match.params;
    const { classes } = this.props;
    
    let imgSrc = ''; 
    try{
      imgSrc = require('./../../../assets/img/'+url+'.jpg').default; 
    }catch{
      imgSrc = undefined; 
    }
    return(
      <div className="product">
        <BackButton />
        <div className="titleSection">
            {imgSrc === undefined ? '' : <TitleCard img={require('./../../../assets/img/'+url+'.jpg').default} />}
            <div>
              <h3>{url}</h3>
              <p>Select version</p>
            </div>
        </div>
        <div className="pTable">
          <TableContainer className={classes.tableContainer}>
          <Table aria-label="collapsible table">
            <TableHead>
              <TableRow>
                <TableCell className={classes.thead} align="left">Name</TableCell>
                <TableCell className={classes.thead} align="right">Firmware Numbers</TableCell>
                <TableCell />
              </TableRow>
            </TableHead>
            <TableBody>
              {this.state.firmwares.map(value => (
                <CollapseRow 
                  key={value.Name} 
                  name={value.Name} 
                  num={value.FirmwareNumbers}
                  onOpen={(setVersions) => this.getVersions(value, setVersions)}
                />
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        </div>
      </div>
    )
  }

}

export default withStyles(styles)(Product);
